import React from "react";

/**
 * PageShell — uniform admin page padding & max width.
 * Inherits the LiveTracking reference page style.
 */
export function PageShell({ children, className = "", testId, dense = false }) {
  const pad = dense ? "p-4 lg:p-6" : "p-6 lg:p-8";
  return (
    <div data-testid={testId} className={`${pad} max-w-[1500px] mx-auto ${className}`}>
      {children}
    </div>
  );
}
